import { Component, Input } from '@angular/core';
import { SemanticQuestionV3 } from '../../../classes/question-semantic';
import { QuestionBaseV3ComponentDirective } from '../question-base.component';

@Component({
  selector: 'bepatient-input-semantic-v3',
  templateUrl: './input-semantic.component.html',
  styleUrls: ['./input-semantic.component.scss'],
  standalone: false
})
export class InputSemanticComponentV3 extends QuestionBaseV3ComponentDirective {
  @Input() question: SemanticQuestionV3;
  @Input() color: string;
}
